import React from 'react';

const clients = [
  'Nashik MahaGenCo Thermal Power Station (NTPS)',
  'NTPC Talcher, Orissa',
  'Thermal Power Station, Parali',
  'Thermal Power Station, Bhusawal',
  'Thermal Power Station, Paras',
  'Thermal Power Station, Chandrapur',
  'Thermal Power Station, Koradi',
  'Thermal Power Station, Khaperkheda',
  'Thermal Power Station, Bangalore',
  'Chitale Dairy, Sangli',
  'Autoparts Forging Pvt. Ltd., Jaisingpur',
  'Verron Industries Ltd., Ratnagiri',
  'Sadamate Industries, Palus',
  'Malti Industries, Palus',
  'Vikrant Metal Industries, Palus',
  'Padmavati Forge Pvt. Ltd., Kolhapur',
];

const KeyClients = () => {
  return (
    <section className="section light" id="key-clients">
      <h2 className="section-title">Trusted by Industry Leaders</h2>
      <p className="section-subtitle">
        Deployed across state utilities, forging clusters and high‑duty process
        industries where downtime is not an option.
      </p>
      <div className="cards">
        {clients.map((client, idx) => (
          <div key={idx} className="card">
            <h3 style={{ fontSize: '0.95rem', marginBottom: 0 }}>{client}</h3>
          </div>
        ))}
      </div>
    </section>
  );
};

export default KeyClients;